import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { InputMask } from 'primeng/inputmask';

// Patch PrimeNG InputMask Android handler to guard against undefined caret()
function patchPrimeNgInputMaskAndroidCaret(): void {
  const patchHandleAndroidInput = (proto: any) => {
    if (!proto || typeof proto.handleAndroidInput !== 'function') {
      return;
    }

    const original = proto.handleAndroidInput;
    if ((original as any).__fwPatched) {
      return;
    }

    proto.handleAndroidInput = function (event: Event) {
      const caretResult = typeof this.caret === 'function' ? this.caret() : null;

      // If caret is not available (e.g., input not attached/active yet),
      // fall back to the non-Android handler or safely no-op instead of crashing.
      if (!caretResult || typeof caretResult.begin !== 'number') {
        if (typeof this.handleInputChange === 'function') {
          return this.handleInputChange(event);
        }
        return;
      }

      return original.call(this, event);
    };

    (proto.handleAndroidInput as any).__fwPatched = true;
  };

  try {
    patchHandleAndroidInput((InputMask as any).prototype);
  } catch {
    // ignore – defensive patch only
  }
}

patchPrimeNgInputMaskAndroidCaret();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
